import React from 'react';

import NibInput from '../NibInput/NibInput';

const InputPassword = ({ formik, label, required, placeholder, name, helperText, newUI, ...props }) => {
  return (
    <NibInput
      tools={['info', 'hide']}
      hideOnInit
      required
      name={name}
      placeholder={placeholder}
      label={label}
      variant={'filled'}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      style={{ width: '100%' }}
      value={formik.values[name] || ''}
      error={formik.touched[name] && formik.errors[name]}
      helperText={helperText}
      newUI={newUI}
    />
  );
};

export default InputPassword;
